import { Box, IconButton } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../api/hooks/useColors";
import useSmartAndRegularAssets from "../../../../../api/hooks/useSmartAndRegularAssets";
import CustomTooltip from "../../../../../components/CustomTooltip";
import StyledDataGrid from "../../../../../components/StyledDataGrid";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { AssetClass } from "../../../../../utils/constants";
import EntityDrawer from "../../../environment/components/EntityDrawer/EntityDrawer";
import { getSharedColumns } from "../../../environment/entitiesTable/sharedColumns";
import { icons } from "../../../environment/icons/iconExport";

const EntitiesAssetWizardTable = ({
  formData,
  setFormData,
  assetToEdit = null,
}) => {
  const colors = useColors();
  const { regularAndActiveSmartAsset: assets } =
    useSmartAndRegularAssets(false);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const removeEntityFromAsset = (entityId) => {
    setFormData((prevData) => ({
      ...prevData,
      stepManualAdd: {
        entities: prevData.stepManualAdd.entities.filter(
          (entity) => entity.id !== entityId
        ),
        entitiesSelected: prevData.stepManualAdd.entitiesSelected.filter(
          (entity) => entity.id !== entityId
        ),
      },
    }));
  };

  const deleteEntityColumn = {
    field: "delete",
    headerName: "",
    renderCell: (params) => {
      return (
        <CustomTooltip title="Remove entity from asset" placement="top">
          <IconButton onClick={() => removeEntityFromAsset(params.row.id)}>
            <SvgToIcon
              IconLogo={icons.RemoveCircleIcon}
              width="18px"
              style={{
                color: colors.icon_action_active,
              }}
            />
          </IconButton>
        </CustomTooltip>
      );
    },
  };

  const columns = getSharedColumns(assets);
  if (assetToEdit?.asset?.cls !== AssetClass.SMART) {
    columns.push(deleteEntityColumn);
  }

  return (
    <Box sx={{ width: "100%" }}>
      {formData.stepManualAdd?.entities?.length > 0 && (
        <StyledDataGrid
          checkboxSelection={false}
          disableRowSelectionOnClick
          columns={columns}
          rows={formData.stepManualAdd.entities}
          onCellClick={(params, event) => {
            if (params.field === "delete") {
            } else {
              setSelectedRow(params.row);
              setOpenDrawer(true);
            }
          }}
          pageSizeOptionsOverride={[5]}
        />
      )}
      {selectedRow && (
        <EntityDrawer
          openDrawer={openDrawer}
          selectedEntity={selectedRow}
          onClose={() => {
            setOpenDrawer(false);
            setSelectedRow(null);
          }}
        />
      )}
    </Box>
  );
};

export default EntitiesAssetWizardTable;
